//xterme zone project photos
import pXtreme1 from '../../Assets/images/xtreme-project-1.jpg';
import pXtremewebp1 from '../../Assets/images/xtreme-project-1.webp';
import pXtreme2 from '../../Assets/images/xtreme-project-2.jpg';
import pXtremewebp2 from '../../Assets/images/xtreme-project-2.webp';
import pXtreme3 from '../../Assets/images/xtreme-project-3.jpg';
import pXtremewebp3 from '../../Assets/images/xtreme-project-3.webp';
import pXtreme4 from '../../Assets/images/xtreme-project-4.jpg';
import pXtremewebp4 from '../../Assets/images/xtreme-project-4.webp';
import pXtreme5 from '../../Assets/images/xtreme-project-5.jpg';
import pXtremewebp5 from '../../Assets/images/xtreme-project-5.webp';
//Qanal water project photos
import pQana1 from '../../Assets/images/qana-project-1.jpg';
import pQanaWebp1 from '../../Assets/images/qana-project-1.webp';
import pQana2 from '../../Assets/images/qana-project-2.jpg';
import pQanaWebp2 from '../../Assets/images/qana-project-2.webp';
import pQana3 from '../../Assets/images/qana-project-3.jpg';
import pQanaWebp3 from '../../Assets/images/qana-project-3.webp';
import pQana4 from '../../Assets/images/qana-project-4.jpg';
import pQanaWebp4 from '../../Assets/images/qana-project-4.webp';
//reem mall project photos
import pReemMall1 from '../../Assets/images/rmall-project-1.png';
import pReemMallWebp1 from '../../Assets/images/rmall-project-1.webp';
import pReemMall2 from '../../Assets/images/rmall-project-2.jpg';
import pReemMallWebp2 from '../../Assets/images/rmall-project-2.webp';
import pReemMall3 from '../../Assets/images/rmall-project-3.png';
import pReemMallWebp3 from '../../Assets/images/rmall-project-3.webp';
import pReemMall4 from '../../Assets/images/rmall-project-4.png';
import pReemMallWebp4 from '../../Assets/images/rmall-project-4.webp';
import pReemMall5 from '../../Assets/images/rmall-project-5.png';
import pReemMallWebp5 from '../../Assets/images/rmall-project-5.webp';
//zayed port project photos
import pZayed1 from '../../Assets/images/zayed-project-1.jpg';
import pZayedWebp1 from '../../Assets/images/zayed-project-1.webp';
import pZayed2 from '../../Assets/images/zayed-project-2.jpg';
import pZayedWebp2 from '../../Assets/images/zayed-project-2.webp';
import pZayed3 from '../../Assets/images/zayed-project-3.jpg';
import pZayedWebp3 from '../../Assets/images/zayed-project-3.webp';
import pZayed4 from '../../Assets/images/zayed-project-4.jpg';
import pZayedWebp4 from '../../Assets/images/zayed-project-4.webp';
import pZayed5 from '../../Assets/images/zayed-project-5.jpg';
import pZayedWebp5 from '../../Assets/images/zayed-project-5.webp';
import pZayed6 from '../../Assets/images/zayed-project-6.jpg';
import pZayedWebp6 from '../../Assets/images/zayed-project-6.webp';
//carson tower project photos
import pCarson1 from '../../Assets/images/carson-project-1.jpg';
import pCarsonWebp1 from '../../Assets/images/carson-project-1.webp';
import pCarson2 from '../../Assets/images/carson-project-2.jpg';
import pCarsonWebp2 from '../../Assets/images/carson-project-2.webp';
import pCarson3 from '../../Assets/images/carson-project-3.jpg';
import pCarsonWebp3 from '../../Assets/images/carson-project-3.webp';
import pCarson4 from '../../Assets/images/carson-project-4.jpg';
import pCarsonWebp4 from '../../Assets/images/carson-project-4.webp';
import pCarson5 from '../../Assets/images/carson-project-5.jpg';
import pCarsonWebp5 from '../../Assets/images/carson-project-5.webp';
//residental building project photos
import pRes1 from '../../Assets/images/res-project-1.jpg';
import pResWebp1 from '../../Assets/images/res-project-1.webp';
import pRes2 from '../../Assets/images/res-project-2.jpg';
import pResWebp2 from '../../Assets/images/res-project-2.webp';
import pRes3 from '../../Assets/images/res-project-3.jpg';
import pResWebp3 from '../../Assets/images/res-project-3.webp';
import pRes4 from '../../Assets/images/res-project-4.jpg';
import pResWebp4 from '../../Assets/images/res-project-4.webp';
// pixeles project photos
import pPixels1 from '../../Assets/images/pixels-project-1.jpg';
import pPixelsWebp1 from '../../Assets/images/pixels-project-1.webp';
import pPixels2 from '../../Assets/images/pixels-project-2.jpg';
import pPixelsWebp2 from '../../Assets/images/pixels-project-2.webp';
import pPixels3 from '../../Assets/images/pixels-project-3.jpg';
import pPixelsWebp3 from '../../Assets/images/pixels-project-3.webp';
import pPixels4 from '../../Assets/images/pixels-project-4.jpg';
import pPixelsWebp4 from '../../Assets/images/pixels-project-4.webp';
import pPixels5 from '../../Assets/images/pixels-project-5.jpg';
import pPixelsWebp5 from '../../Assets/images/pixels-project-5.webp';
import pPixels6 from '../../Assets/images/pixels-project-6.jpg';
import pPixelsWebp6 from '../../Assets/images/pixels-project-6.webp';
//Villas
import villa1 from '../../Assets/images/v1.jpg';
import villawebp1 from '../../Assets/images/v1.webp';
import villa2 from '../../Assets/images/v2.jpg';
import villawebp2 from '../../Assets/images/v2.webp';
import villa3 from '../../Assets/images/v3.jpg';
import villawebp3 from '../../Assets/images/v3.webp';
import villa4 from '../../Assets/images/v4.jpg';
import villawebp4 from '../../Assets/images/v4.webp';
import villa5 from '../../Assets/images/pvilla2-1.jpg';
import villawebp5 from '../../Assets/images/pvilla2-1.webp';
import villa6 from '../../Assets/images/pvilla3-1.jpg';
import villawebp6 from '../../Assets/images/pvilla3-1.webp';
//private villa 1
import pvilla1_1 from '../../Assets/images/pvilla1-1.jpg';
import pvilla1webp1_1 from '../../Assets/images/pvilla1-1.webp';
import pvilla1_2 from '../../Assets/images/pvilla1-2.jpg';
import pvilla1webp1_2 from '../../Assets/images/pvilla1-2.webp';
import pvilla1_3 from '../../Assets/images/pvilla1-3.jpg';
import pvilla1webp1_3 from '../../Assets/images/pvilla1-3.webp';
import pvilla1_4 from '../../Assets/images/pvilla1-4.jpg';
import pvilla1webp1_4 from '../../Assets/images/pvilla1-4.webp';
//private villa 2
import pvilla2_1 from '../../Assets/images/pvilla2-1.jpg';
import pvilla1webp2_1 from '../../Assets/images/pvilla2-1.webp';
import pvilla2_2 from '../../Assets/images/pvilla2-2.jpg';
import pvilla1webp2_2 from '../../Assets/images/pvilla2-2.webp';
import pvilla2_3 from '../../Assets/images/pvilla2-3.jpg';
import pvilla1webp2_3 from '../../Assets/images/pvilla2-3.webp';
import pvilla2_4 from '../../Assets/images/pvilla2-4.jpg';
import pvilla1webp2_4 from '../../Assets/images/pvilla2-4.webp';
//private villa 3
import pvilla3_1 from '../../Assets/images/pvilla3-1.jpg';
import pvilla1webp3_1 from '../../Assets/images/pvilla3-1.webp';
import pvilla3_2 from '../../Assets/images/pvilla3-2.jpg';
import pvilla1webp3_2 from '../../Assets/images/pvilla3-2.webp';
import pvilla3_3 from '../../Assets/images/pvilla3-3.jpg';
import pvilla1webp3_3 from '../../Assets/images/pvilla3-3.webp';
//private villa 4
import pvilla4_1 from '../../Assets/images/pvilla4-1.jpg';
import pvilla1webp4_1 from '../../Assets/images/pvilla4-1.webp';
import pvilla4_2 from '../../Assets/images/pvilla4-2.jpg';
import pvilla1webp4_2 from '../../Assets/images/pvilla4-2.webp';
import pvilla4_3 from '../../Assets/images/pvilla4-3.jpg';
import pvilla1webp4_3 from '../../Assets/images/pvilla4-3.webp';
import pvilla4_4 from '../../Assets/images/pvilla4-4.jpg';
import pvilla1webp4_4 from '../../Assets/images/pvilla4-4.webp';
//private villa 5
import pvilla5_1 from '../../Assets/images/pvilla5-1.jpg';
import pvilla1webp5_1 from '../../Assets/images/pvilla5-1.webp';
import pvilla5_2 from '../../Assets/images/pvilla5-2.jpg';
import pvilla1webp5_2 from '../../Assets/images/pvilla5-2.webp';
import pvilla5_3 from '../../Assets/images/pvilla5-3.jpg';
import pvilla1webp5_3 from '../../Assets/images/pvilla5-3.webp';
import pvilla5_4 from '../../Assets/images/pvilla5-4.jpg';
import pvilla1webp5_4 from '../../Assets/images/pvilla5-4.webp';
//private villa 6
import pvilla6_1 from '../../Assets/images/pvilla6-1.jpg';
import pvilla1webp6_1 from '../../Assets/images/pvilla6-1.webp';
import pvilla6_2 from '../../Assets/images/pvilla6-2.jpg';
import pvilla1webp6_2 from '../../Assets/images/pvilla6-2.webp';
import pvilla6_3 from '../../Assets/images/pvilla6-3.jpg';
import pvilla1webp6_3 from '../../Assets/images/pvilla6-3.webp';
import pvilla6_4 from '../../Assets/images/pvilla6-4.jpg';
import pvilla1webp6_4 from '../../Assets/images/pvilla6-4.webp';
//private villa 7
import pvilla7_1 from '../../Assets/images/pvilla7-1.jpg';
import pvilla1webp7_1 from '../../Assets/images/pvilla7-1.webp';
import pvilla7_2 from '../../Assets/images/pvilla7-2.jpg';
import pvilla1webp7_2 from '../../Assets/images/pvilla7-2.webp';
import pvilla7_3 from '../../Assets/images/pvilla7-3.jpg';
import pvilla1webp7_3 from '../../Assets/images/pvilla7-3.webp';
import pvilla7_4 from '../../Assets/images/pvilla7-4.jpg';
import pvilla1webp7_4 from '../../Assets/images/pvilla7-4.webp';




const Projectsdata ={
    title:'projects',
    // slideContent: 'we take great pride in our projects',
    // projectTitle:'Macline group is dedicated to taking a pure idea and bringing it to fruition through careful design and construction while respecting every aspect of your vision. Employing that philosophy, we’re extremely proud to be playing a vital role in the development of the following projects:',
    project:[
    {
        id:1,
        name:'AL Qana Water Development',
        // deatils: "Civil - Plaster and Paint work",
        serviceName:'Exterior',
        place:'',
        slide:true,
        image:
        [
            {
                id:1,
                imagePath:pQana1,
                imagePathWebp:pQanaWebp1,
            },
            {
                id:2,
                imagePath:pQana2,
                imagePathWebp:pQanaWebp2,
            },
            {
                id:3,
                imagePath:pQana3,
                imagePathWebp:pQanaWebp3,
            },
            {
                id:4,
                imagePath:pQana4,
                imagePathWebp:pQanaWebp4,
            },
        ],
        imageAlt: 'AL-Qana-Water project',
    },
    {
        id:2,
        name:'Pixels Reem Island',
        serviceName:'Interior',
        // deatils: "Civil and MEP: Tile, Plumbing and Electrical Work",
        place:'China State',
        slide:false,
        image:
        [
            {
                id:1,
                imagePath:pPixels1,
                imagePathWebp:pPixelsWebp1,
            },
            {
                id:2,
                imagePath:pPixels2,
                imagePathWebp:pPixelsWebp2,
            },
            {
                id:3,
                imagePath:pPixels3,
                imagePathWebp:pPixelsWebp3,
            },
            {
                id:4,
                imagePath:pPixels4,
                imagePathWebp:pPixelsWebp4,
            },
            {
                id:5,
                imagePath:pPixels5,
                imagePathWebp:pPixelsWebp5,
            },
            {
                id:6,
                imagePath:pPixels6,
                imagePathWebp:pPixelsWebp6,
            },
        ],
        imageAlt: 'project Pixels-Reem-Island'
    },
    {
        id:3,
        name:'Reem Mall',
        serviceName:'MEP',
        // deatils: "Removal of marble and external painting",
        place:'Reem island',
        slide:false,
        image:
        [
            {
                id:1,
                imagePath:pReemMall1,
                imagePathWebp:pReemMallWebp1,
            },
            {
                id:2,
                imagePath:pReemMall2,
                imagePathWebp:pReemMallWebp2,
            },
            {
                id:3,
                imagePath:pReemMall3,
                imagePathWebp:pReemMallWebp3,
            },
            {
                id:4,
                imagePath:pReemMall4,
                imagePathWebp:pReemMallWebp4,
            },
            {
                id:5,
                imagePath:pReemMall5,
                imagePathWebp:pReemMallWebp5,
            },
        ],
        imageAlt: 'project Reem-Mall'
    },
    {
        id:4,
        name:'Zayed Port',
        // deatils: " Mac Line Group",
        serviceName:'Civil-Work',
        place:'Abu Dhabi',
        slide:false,
        image:
        [
            {
                id:1,
                imagePath:pZayed1,
                imagePathWebp:pZayedWebp1,
            },
            {
                id:2,
                imagePath:pZayed2,
                imagePathWebp:pZayedWebp2,
            },
            {
                id:3,
                imagePath:pZayed3,
                imagePathWebp:pZayedWebp3,
            },
            {
                id:4,
                imagePath:pZayed4,
                imagePathWebp:pZayedWebp4,
            },
            {
                id:5,
                imagePath:pZayed5,
                imagePathWebp:pZayedWebp5,
            },
            {
                id:6,
                imagePath:pZayed6,
                imagePathWebp:pZayedWebp6,
            },
        ],
        imageAlt: 'project Zayed-Port'
    },
    {
        id:5,
        name:'Extreme Zone ',
        // deatils: " Aztec Middle East Contracting LLC",
        serviceName:'Interior',
        place:'Galleria Mall',
        slide:true,
        image:
        [
            {
                id:1,
                imagePath:pXtreme1,
                imagePathWebp:pXtremewebp1,
            },
            {
                id:2,
                imagePath:pXtreme2,
                imagePathWebp:pXtremewebp2,
            },
            {
                id:3,
                imagePath:pXtreme3,
                imagePathWebp:pXtremewebp3,
            },
            {
                id:4,
                imagePath:pXtreme4,
                imagePathWebp:pXtremewebp4,
            },
            {
                id:5,
                imagePath:pXtreme5,
                imagePathWebp:pXtremewebp5,
            },
        ],
        imageAlt: 'project Extreme-Zone'
    },
    {
        id:6,
        name:'Carson Tower',
        serviceName:'Flooring',
        // deatils: " Mac Line Group (Renovation Works)",
        place:'Damac Hills',
        slide:true,
        image:
        [
            {
                id:1,
                imagePath:pCarson1,
                imagePathWebp:pCarsonWebp1,
            },
            {
                id:2,
                imagePath:pCarson2,
                imagePathWebp:pCarsonWebp2,
            },
            {
                id:3,
                imagePath:pCarson3,
                imagePathWebp:pCarsonWebp3,
            },
            {
                id:4,
                imagePath:pCarson4,
                imagePathWebp:pCarsonWebp4,
            },
            {
                id:5,
                imagePath:pCarson5,
                imagePathWebp:pCarsonWebp5,
            },
        ],
        imageAlt: 'project Carson-Tower'
    },
    {
        id:7,
        name:'Residential Building ',
        // deatils: " Belhasa Projects LLC",
        serviceName:'civil-Work',
        place:'Reem Island',
        slide:false,
        image:
        [
            {
                id:1,
                imagePath:pRes1,
                imagePathWebp:pResWebp1,
            },
            {
                id:2,
                imagePath:pRes2,
                imagePathWebp:pResWebp2,
            },
            {
                id:3,
                imagePath:pRes3,
                imagePathWebp:pResWebp3,
            },
            {
                id:4,
                imagePath:pRes4,
                imagePathWebp:pResWebp4,
            },
        ],
        imageAlt: 'project Residential-Building'
    },
    {
        id:8,
        name:'Villas Projects',
        serviceName:'Renovation',
        // deatils: " AG facilities and Contracting",
        place:'UAE',
        slide:false,
        image:
        [
            {
                id:1,
                imagePath:villa1,
                imagePathWebp:villawebp1,
            },
            {
                id:2,
                imagePath:villa2,
                imagePathWebp:villawebp2,
            },
            {
                id:3,
                imagePath:villa3,
                imagePathWebp:villawebp3,
            },
            {
                id:4,
                imagePath:villa4,
                imagePathWebp:villawebp4,
            },
            {
                id:5,
                imagePath:villa5,
                imagePathWebp:villawebp5,
            },
            {
                id:6,
                imagePath:villa6,
                imagePathWebp:villawebp6,
            },
        ],
        imageAlt: 'Villas-Projects'
    },
    {
        id:9,
        name:'Private Villa',
        // deatils: " Al Reyami Interiors",
        serviceName:'',
        place:'Abu Dhabi Madinat Al Riyad',
        slide:false,
        image:
        [
            {
                id:1,
                imagePath:pvilla1_1,
                imagePathWebp:pvilla1webp1_1,
            },
            {
                id:2,
                imagePath:pvilla1_2,
                imagePathWebp:pvilla1webp1_2,
            },
            {
                id:3,
                imagePath:pvilla1_3,
                imagePathWebp:pvilla1webp1_3,
            },
            {
                id:4,
                imagePath:pvilla1_4,
                imagePathWebp:pvilla1webp1_4,
            },
        ],
        imageAlt: 'project Private-Villa'
    },
    {
        id:10,
        name:'Private Villa',
        // deatils: "Civil and MEP,Epoxy Paint Works",
        serviceName:'',
        place:'Abu Dhabi Al Shawamekh',
        slide:true,
        image:
        [
            {
                id:1,
                imagePath:pvilla2_1,
                imagePathWebp:pvilla1webp2_1,
            },
            {
                id:2,
                imagePath:pvilla2_2,
                imagePathWebp:pvilla1webp2_2,
            },
            {
                id:3,
                imagePath:pvilla2_3,
                imagePathWebp:pvilla1webp2_3,
            },
            {
                id:4,
                imagePath:pvilla2_4,
                imagePathWebp:pvilla1webp2_4,
            },
        ],
        imageAlt: 'project Private-Villa'
    },
    {
        id:11,
        name:'Private Villa',
        serviceName:'Renovation',
        // deatils: " AG facilities and Contracting",
        place:'Abu Dhabi Saadiyat',
        slide:false,
        image:
        [
            {
                id:1,
                imagePath:pvilla3_1,
                imagePathWebp:pvilla1webp3_1,
            },
            {
                id:2,
                imagePath:pvilla3_2,
                imagePathWebp:pvilla1webp3_2,
            },
            {
                id:3,
                imagePath:pvilla3_3,
                imagePathWebp:pvilla1webp3_3,
            },
        ],
        imageAlt: 'project Private-Villa'
    },
    {
        id:12,
        name:'Private Villa',
        serviceName:'Renovation',
        // deatils: "EIFS System Installation Work",
        place:'Abu Dhabi Saadiyat',
        slide:true,
        image:
        [
            {
                id:1,
                imagePath:pvilla4_1,
                imagePathWebp:pvilla1webp4_1,
            },
            {
                id:2,
                imagePath:pvilla4_2,
                imagePathWebp:pvilla1webp4_2,
            },
            {
                id:3,
                imagePath:pvilla4_3,
                imagePathWebp:pvilla1webp4_3,
            },
            {
                id:4,
                imagePath:pvilla4_4,
                imagePathWebp:pvilla1webp4_4,
            },
        ],
        imageAlt: 'projects Private-Villa'
    },
    {
        id:13,
        name:'Private Villa',
        serviceName:'Renovation',
        // deatils: "EIFS System Installation Work",
        place:'Abu Dhabi Saadiyat',
        slide:true,
        image:
        [
            {
                id:1,
                imagePath:pvilla5_1,
                imagePathWebp:pvilla1webp5_1,
            },
            {
                id:2,
                imagePath:pvilla5_2,
                imagePathWebp:pvilla1webp5_2,
            },
            {
                id:3,
                imagePath:pvilla5_3,
                imagePathWebp:pvilla1webp5_3,
            },
            {
                id:4,
                imagePath:pvilla5_4,
                imagePathWebp:pvilla1webp5_4,
            },
        ],
        imageAlt: 'projects Private-Villa'
    },
    {
        id:14,
        name:'Private Villa',
        serviceName:'Renovation',
        // deatils: "EIFS System Installation Work",
        place:'Abu Dhabi Saadiyat',
        slide:false,
        image:
        [
            {
                id:1,
                imagePath:pvilla6_1,
                imagePathWebp:pvilla1webp6_1,
            },
            {
                id:2,
                imagePath:pvilla6_2,
                imagePathWebp:pvilla1webp6_2,
            },
            {
                id:3,
                imagePath:pvilla6_3,
                imagePathWebp:pvilla1webp6_3,
            },
            {
                id:4,
                imagePath:pvilla6_4,
                imagePathWebp:pvilla1webp6_4,
            },
        ],
        imageAlt: 'projects Private-Villa'
    },
    {
        id:15,
        name:'Private Villa',
        serviceName:'Renovation',
        // deatils: "EIFS System Installation Work",
        place:'Abu Dhabi Saadiyat',
        slide:false,
        image:
        [
            {
                id:1,
                imagePath:pvilla7_1,
                imagePathWebp:pvilla1webp7_1,
            },
            {
                id:2,
                imagePath:pvilla7_2,
                imagePathWebp:pvilla1webp7_2,
            },
            {
                id:3,
                imagePath:pvilla7_3,
                imagePathWebp:pvilla1webp7_3,
            },
            {
                id:4,
                imagePath:pvilla7_4,
                imagePathWebp:pvilla1webp7_4,
            },
        ],
        imageAlt: 'projects Private-Villa'
    },
    {
        id:16,
        name:'Private Villa',
        serviceName:'Renovation',
        // deatils: "EIFS System Installation Work",
        place:'Abu Dhabi Saadiyat',
        slide:false,

        image:
        [
            {
                id:1,
                imagePath:pXtreme1,
                imagePathWebp:pXtremewebp1,
            },
            {
                id:2,
                imagePath:pXtreme2,
                imagePathWebp:pXtremewebp2,
            },
            {
                id:3,
                imagePath:pXtreme3,
                imagePathWebp:pXtremewebp3,
            },
        ],
        imageAlt: 'projects Private-Villa'
    },
    {
        id:17,
        name:'Private Villa',
        serviceName:'Renovation',
        // deatils: "EIFS System Installation Work",
        place:'Abu Dhabi Saadiyat',
        slide:false,
        image:
        [
            {
                id:1,
                imagePath:pXtreme1,
                imagePathWebp:pXtremewebp1,
            },
            {
                id:2,
                imagePath:pXtreme2,
                imagePathWebp:pXtremewebp2,
            },
            {
                id:3,
                imagePath:pXtreme3,
                imagePathWebp:pXtremewebp3,
            },
        ],
        imageAlt: 'projects Private-Villa'
    },
]}


export default Projectsdata;